import { useStoreGetters } from '@/store/index'
import { computed, unref } from 'vue-demi'
import { mapGetters } from 'vuex'

export const useEnableCms = () => {
  const {
    enableProjectFeature,
    enableTenderFeature,
  } = useStoreGetters('regions', ['enableProjectFeature', 'enableTenderFeature'])
  return computed(() => unref(enableProjectFeature) || unref(enableTenderFeature))
}

export default {
  computed: {
    ...mapGetters('regions', ['enableProjectFeature', 'enableTenderFeature']),
    enableCms () {
      return this.enableProjectFeature || this.enableTenderFeature
    },
  },
}
